import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { supplier } from '../models/supplier';
import { PageEvent } from '@angular/material/paginator';
import { Page } from '../../shared/models/page.model';


@Injectable({
  providedIn: 'root'
})
export class SuppliersService {

  private url = environment.apiUrl + '/api/suppliers';

  constructor(private http: HttpClient) {}

  createSupplier(supplier: any) {
    return this.http.post<any>(`${this.url}/create`, supplier);
  }

  getSuppliers(page: number, size: number, filter: string) {
    let params = new HttpParams()
      .append('page', page.toString())
      .append('size', size.toString())
      .append('filter', filter)

    return this.http.get<Page<supplier>>(`${this.url}/list`, {params});
  }

  getSuppliersByOrderId(orderId: number) {
    let params = new HttpParams().append('orderId', orderId);
    return this.http.get<supplier[]>(`${this.url}/all`, { params });
  }

  updateSupplier(id: number, supplier: any) {
    return this.http.put<any>(`${this.url}/${id}`, supplier)
  }

  deleteSupplier(supplier:supplier ,id: number) {
    return this.http.put<any>(`${this.url}/deactivate/${id}`,supplier )
  }
}
